<div class="auth-shell">
  <app-auth-showcase></app-auth-showcase>

  <section class="auth-panel">
    <div class="auth-panel__card">
      <div class="auth-panel__switch">
        <app-language-switch></app-language-switch>
      </div>

      <div class="auth-panel__header">
        <h2>{{ 'signUp.title' | t:'Sign Up' }}</h2>
        <p>{{ localize(formSubtitle) }}</p>
      </div>

      <div class="signup-stepper mb-20">
        <button type="button" [class.active]="currentStep === 1" (click)="goToStep(1)">{{ 'signUp.stepProfile' | t:'1.
          Profile' }}</button>
        <button type="button" [class.active]="currentStep === 2" (click)="goToStep(2)">{{ 'signUp.stepCredentials' |
          t:'2. Credentials' }}</button>
        <button type="button" [class.active]="currentStep === 3" (click)="goToStep(3)">{{ 'signUp.stepOtp' | t:'3. OTP'
          }}</button>
      </div>

      <form *ngIf="currentStep === 1" [formGroup]="stepOneForm" (ngSubmit)="continueToCredentials()" class="auth-form"
        novalidate>
        <div class="form-group">
          <input type="text" formControlName="fullName" [placeholder]="'placeholder.typeFullName' | t:'Type full name'"
            required (focus)="onFieldFocus('fullName')" (blur)="onFieldBlur(stepOneForm, 'fullName')" />
          <div class="field-error" *ngIf="shouldShowFieldError(stepOneForm, 'fullName', 'required')">Full name is
            required.</div>
        </div>
        <div class="form-group">
          <input type="text" formControlName="organizationName"
            [placeholder]="'placeholder.typeOrganizationName' | t:'Type organization/housing name'" required
            (focus)="onFieldFocus('organizationName')" (blur)="onFieldBlur(stepOneForm, 'organizationName')" />
          <div class="field-error" *ngIf="shouldShowFieldError(stepOneForm, 'organizationName', 'required')">
            Organization/Housing name is required.</div>
        </div>
        <div class="form-group">
          <div class="mobile-input-wrap">
            <span class="mobile-prefix">{{ mobilePrefix }}</span>
            <input type="tel" inputmode="numeric" formControlName="mobileNumber"
              [placeholder]="'placeholder.typeMobileNumber' | t:'Type mobile number'"
              (focus)="onFieldFocus('mobileNumber')"
              (blur)="normalizeMobileInput(); onFieldBlur(stepOneForm, 'mobileNumber')" />
          </div>
          <div class="field-error" *ngIf="shouldShowFieldError(stepOneForm, 'mobileNumber', 'pattern')">Enter a valid
            mobile number.</div>
        </div>
        <button type="submit" class="submit-btn">
          {{ 'signUp.next' | t:'Next' }}
        </button>
        <div class="message success" *ngIf="status && currentStep === 1"><span [innerHTML]="status"></span></div>
      </form>

      <form *ngIf="currentStep === 2" [formGroup]="stepTwoForm" (ngSubmit)="requestOtp()" class="auth-form" novalidate>
        <div class="form-group">
          <input type="email" formControlName="email" [placeholder]="'signIn.emailPlaceholder' | t:'Type Email'"
            required (focus)="onFieldFocus('email')" (blur)="onFieldBlur(stepTwoForm, 'email')" />
          <div class="field-error" *ngIf="shouldShowFieldError(stepTwoForm, 'email', 'required')">Email is required.
          </div>
          <div class="field-error" *ngIf="shouldShowFieldError(stepTwoForm, 'email', 'email')">Enter a valid email
            address.</div>
          <div class="field-error" *ngIf="shouldShowFieldError(stepTwoForm, 'email', 'emailAlreadyInUse')">Email already
            in use.</div>
        </div>
        <div class="form-group">
          <span class="profile-password-input-wrap">
            <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
              [placeholder]="'signIn.passwordPlaceholder' | t:'Type Password'" required (focus)="onFieldFocus('password')"
              (blur)="onFieldBlur(stepTwoForm, 'password')" />
            <button type="button" class="profile-password-toggle inside" (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? ('topHeader.hideNewPassword' | t:'Hide password') : ('topHeader.showNewPassword' | t:'Show password')">
              <svg *ngIf="!showPassword" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 5C6.5 5 2.12 8.44 1 12c1.12 3.56 5.5 7 11 7s9.88-3.44 11-7c-1.12-3.56-5.5-7-11-7Zm0 11a4 4 0 1 1 0-8a4 4 0 0 1 0 8Z"></path>
              </svg>
              <svg *ngIf="showPassword" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M2.7 1.29L1.29 2.7l4 4C3.52 8.03 2.14 9.86 1 12c1.12 3.56 5.5 7 11 7c2.3 0 4.38-.6 6.12-1.62l3.17 3.17l1.41-1.41L2.7 1.29ZM12 17c-3.98 0-7.14-2.27-8.56-5c.74-1.42 1.87-2.7 3.28-3.63l1.53 1.53A4 4 0 0 0 14.1 15.75l1.56 1.56c-1.08.43-2.3.69-3.66.69Zm0-10c3.98 0 7.14 2.27 8.56 5c-.53 1.03-1.28 1.99-2.19 2.8l-1.43-1.43A4 4 0 0 0 10.63 7.6L9.01 5.98c.93-.31 1.93-.48 2.99-.48Z"></path>
              </svg>
            </button>
          </span>

          <div class="mt-10">
            <span class="profile-password-input-wrap">
              <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                [placeholder]="'placeholder.retypeNewPassword' | t:'Retype Password'" required
                (focus)="onFieldFocus('confirmPassword')" (blur)="onFieldBlur(stepTwoForm, 'confirmPassword')" />
              <button type="button" class="profile-password-toggle inside" (click)="toggleConfirmPasswordVisibility()" [attr.aria-label]="showConfirmPassword ? ('topHeader.hideRetypePassword' | t:'Hide retype password') : ('topHeader.showRetypePassword' | t:'Show retype password')">
                <svg *ngIf="!showConfirmPassword" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 5C6.5 5 2.12 8.44 1 12c1.12 3.56 5.5 7 11 7s9.88-3.44 11-7c-1.12-3.56-5.5-7-11-7Zm0 11a4 4 0 1 1 0-8a4 4 0 0 1 0 8Z"></path>
                </svg>
                <svg *ngIf="showConfirmPassword" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M2.7 1.29L1.29 2.7l4 4C3.52 8.03 2.14 9.86 1 12c1.12 3.56 5.5 7 11 7c2.3 0 4.38-.6 6.12-1.62l3.17 3.17l1.41-1.41L2.7 1.29ZM12 17c-3.98 0-7.14-2.27-8.56-5c.74-1.42 1.87-2.7 3.28-3.63l1.53 1.53A4 4 0 0 0 14.1 15.75l1.56 1.56c-1.08.43-2.3.69-3.66.69Zm0-10c3.98 0 7.14 2.27 8.56 5c-.53 1.03-1.28 1.99-2.19 2.8l-1.43-1.43A4 4 0 0 0 10.63 7.6L9.01 5.98c.93-.31 1.93-.48 2.99-.48Z"></path>
                </svg>
              </button>
            </span>
            <div class="field-error" *ngIf="shouldShowFieldError(stepTwoForm, 'confirmPassword', 'required')">Retype your
              password.</div>
            <div class="field-error" *ngIf="stepOnePasswordMismatch()">Password and retype password must match.</div>
          </div>

          <div class="hint">{{ 'signUp.passwordHint' | t:'Use at least 6 characters.' }}</div>
          <div class="field-error" *ngIf="shouldShowFieldError(stepTwoForm, 'password', 'minlength')">Password must be
            at least 6 characters.</div>
          <div class="strength-indicator">
            <div class="strength-labels">
              @for (bar of strengthBars; track bar) {
              <span [class.filled]="bar.filled"></span>
              }
            </div>
          </div>
        </div>
        <div class="terms-consent" [class.terms-consent--invalid]="shouldShowFieldError(stepTwoForm, 'acceptTerms', 'required')">
          <label class="terms-consent__label">
            <input type="checkbox" formControlName="acceptTerms" />
            <span>
              {{ localize(termsLabelPrefix) }}
              <button type="button" class="terms-link" (click)="openTermsModal($event)">{{ localize(termsLabelLink) }}</button>
              {{ localize(termsLabelSuffix) }}
            </span>
          </label>
          <div class="field-error" *ngIf="shouldShowFieldError(stepTwoForm, 'acceptTerms', 'required')">
            {{ isBangla ? 'সাইন আপ করার আগে শর্তাবলী মেনে নিতে হবে' : 'You must accept the Terms & Conditions before signing up.' }}
          </div>
        </div>
        <button type="submit" [disabled]="isOtpButtonDisabled()" class="submit-btn">
          {{ isSendingOtp ? ('signUp.sendingOtp' | t:'Sending OTP...') : ('signUp.sendOtp' | t:'Send OTP') }}
        </button>
        <div class="message success" *ngIf="status && currentStep === 2"><span [innerHTML]="status"></span></div>
      </form>

      <form *ngIf="currentStep === 3" [formGroup]="stepThreeForm" (ngSubmit)="completeSignup()" class="auth-form"
        novalidate>
        <div class="otp-expire" *ngIf="otpExpiresInSeconds > 0">
          {{ 'signUp.otpExpiresIn' | t:'OTP expires in' }} {{ otpExpireLabel }}
        </div>
        <div class="otp-expired" *ngIf="otpExpiresInSeconds === 0">
          {{ 'signUp.otpExpired' | t:'OTP expired. Please go back and send OTP again.' }}
        </div>
        <div class="form-group">
          <input type="text" formControlName="otp" [placeholder]="'placeholder.typeOtp' | t:'Type OTP'" required
            (focus)="onFieldFocus('otp')" (blur)="onFieldBlur(stepThreeForm, 'otp')" />
          <div class="field-error" *ngIf="shouldShowFieldError(stepThreeForm, 'otp')">Enter a valid OTP (4 to 8 digits).
          </div>
        </div>
        <button type="submit" [disabled]="isRegistering || stepThreeForm.invalid || otpExpiresInSeconds === 0"
          class="submit-btn">
          {{ isRegistering ? ('signUp.creatingAccount' | t:'Creating Account...') : ('signUp.complete' | t:'Complete
          Sign Up') }}
        </button>
        <div class="message success" *ngIf="status && currentStep === 3"><span [innerHTML]="status"></span></div>
      </form>

      <div class="auth-divider">
        <span>{{ isBangla ? 'অথবা' : 'Or' }}</span>
      </div>

      <div class="login-link login-link--boxed">
        <span>{{ 'signUp.alreadyOnHtally' | t:'Already on HTally?' }}</span>
        <a routerLink="/signIn">{{ 'signUp.signIn' | t:'Sign In' }}</a>
      </div>

      <div class="auth-role-card">
        <div class="auth-role-card__title">{{ localize(rolesHeading) }}</div>
        <div class="auth-role-card__list">
          @for (role of roles; track role.text.en) {
          <div class="auth-role-card__item">
            <span class="auth-role-card__icon" [innerHTML]="role.icon"></span>
            <span>{{ localize(role.text) }}</span>
          </div>
          }
        </div>
      </div>

      <div class="message error" *ngIf="error">{{ error }}</div>
    </div>
  </section>
</div>

<div class="otp-modal-overlay" *ngIf="isImageModalOpen" (click)="skipImageStep()">
  <div class="signup-upload-modal" (click)="$event.stopPropagation()">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'"
      (click)="skipImageStep()">&times;</button>
    <h3>{{ 'signUp.imageModalTitle' | t:'Add Organization Logo' }}</h3>
    <p class="upload-hint">{{ 'signUp.imageModalHint' | t:'Optional: You can skip this step and upload later.' }}</p>
    <p class="upload-hint subtle">{{ 'signUp.imageRules' | t:'Allowed: .jpg, .jpeg, .png | Max: 1 file' }}</p>

    <div class="signup-logo-preview-wrap">
      <div class="signup-logo-preview-shell">
        <img *ngIf="selectedImagePreviewUrl; else organizationLogoFallback" [src]="selectedImagePreviewUrl"
          [attr.alt]="'signUp.logoPreviewAlt' | t:'Organization logo preview'" class="signup-logo-preview" />
        <ng-template #organizationLogoFallback>
          <div class="signup-logo-preview-fallback">{{ organizationLogoFallbackLabel }}</div>
        </ng-template>
      </div>
    </div>

    <label class="upload-picker">
      <input type="file" accept=".jpg,.jpeg,.png" (change)="onImageSelected($event)" />
      <span>{{ selectedImageName ? ('common.changeLogo' | t:'Change Logo') : ('common.selectLogo' | t:'Select Logo')
        }}</span>
    </label>

    <div class="upload-selected" *ngIf="selectedImageName; else noUploadFile">
      <div class="upload-count">{{ 'signUp.oneFileSelected' | t:'1 file selected' }}</div>
      <div class="upload-files">
        <div class="upload-file">
          <span class="name">{{ selectedImageName }}</span>
        </div>
      </div>
    </div>
    <ng-template #noUploadFile>
      <div class="upload-empty">{{ 'signUp.noFileSelected' | t:'No file selected.' }}</div>
    </ng-template>

    <div class="message error" *ngIf="error">{{ error }}</div>
    <div class="image-modal-actions upload-actions">
      <button type="button" class="secondary-btn" (click)="skipImageStep()" [disabled]="isFinalizingSignup">{{
        'common.skip' | t:'Skip' }}</button>
      <button type="button" class="submit-btn" (click)="finishWithImage()" [disabled]="isFinalizingSignup">
        {{ isFinalizingSignup ? ('common.saving' | t:'Saving...') : ('common.done' | t:'Done') }}
      </button>
    </div>
  </div>
</div>

<app-image-crop-modal [visible]="!!imageCropSourceFile" [sourceFile]="imageCropSourceFile"
  [title]="'signUp.cropOrganizationLogoTitle' | t:'Crop Organization Logo'"
  [hint]="'signUp.cropOrganizationLogoHint' | t:'Drag the image and adjust zoom to fit the logo area. The cropped image will be compressed before upload.'"
  [outputHint]="'signUp.cropOrganizationLogoOutputHint' | t:'The cropped image will be saved as JPG to reduce upload size.'"
  [confirmLabel]="'common.useCroppedImage' | t:'Use Cropped Image'" [cancelLabel]="'common.cancel' | t:'Cancel'"
  fallbackBaseName="organization-logo" (cancel)="onOrganizationImageCropCancelled()"
  (confirm)="onOrganizationImageCropped($event)"></app-image-crop-modal>

<div class="terms-modal-overlay" *ngIf="isTermsModalOpen" (click)="closeTermsModal()">
  <div class="terms-modal" (click)="$event.stopPropagation()">
    <button class="terms-modal__close" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeTermsModal()">&times;</button>
    <div class="terms-modal__header">
      <h3>{{ localize(termsModalTitle) }}</h3>
      <p>{{ localize(termsModalIntro) }}</p>
    </div>

    <div class="terms-modal__sections">
      @for (section of termsSections; track section.title.en) {
      <section class="terms-modal__section">
        <h4>{{ localize(section.title) }}</h4>
        <ul>
          @for (item of localizeList(section.items); track item) {
          <li>{{ item }}</li>
          }
        </ul>
      </section>
      }
    </div>

    <p class="terms-modal__closing">{{ localize(termsModalClosing) }}</p>

    <div class="terms-modal__actions">
      <button type="button" class="submit-btn" (click)="closeTermsModal()">{{ isBangla ? 'বুঝেছি' : 'Understood' }}</button>
    </div>
  </div>
</div>
